import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { NameSelector } from './selectors/NameSelector';
import { StudyNameField } from './selectors/StudyNameField';
import { NparallelsSelector } from './selectors/NparallelsSelector';
import { NtrialsSelector } from './selectors/NtrialsSelector';

interface Props {
  subtitle: string;
}

export const APPForm: React.FC<Props> = ({ subtitle }) => {
  return (
    <Accordion sx={{ backgroundColor: '#404040', color: '#333' }}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="cfd-content"
        id="cfd-header"
      >
        <CustomTypography >{subtitle}</CustomTypography>
      </AccordionSummary>
      <AccordionDetails>
        <Box component="div">
          <NameSelector label={"Name"} />
        </Box>
        <Box component="div">
          <StudyNameField label={"Study Name"} />
        </Box>
        <Box component="div">
          <NparallelsSelector label={"Num of Parallels"} />
        </Box>
        <Box component="div">
          <NtrialsSelector label={"Num of Trials"} />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
